import _ from 'lodash';
import moment from 'moment';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

//- material-ui
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import UpIcon from '@material-ui/icons/ArrowDropUp';
import DownIcon from '@material-ui/icons/ArrowDropDown';
import WarningIcon from '@material-ui/icons/Warning';
import NoteIcon from '@material-ui/icons/Note';
import FileDownload from '@material-ui/icons/SaveAlt';
// import CheckIcon from '@material-ui/icons/Check';
import LockIcon from '@material-ui/icons/Lock';
import documentIcon from '../../images/document.svg';

//- local
import GasBuddyPricesContainer from '../../containers/reports/GasBuddyPrices';
import GasBuddyIgnoredStationsContainer from '../../containers/reports/GasBuddyIgnoredStations';
import ReportsMonitoringContainer from '../../containers/reports/Monitoring';
import RegistryContainer from '../../containers/Registry';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import { sortStationTable } from '../../libs/utility';

import { getSharedStyles } from '../../themes';
import FormComponent from '../../components/FormComponent';
import StationsContainer from '../../containers/Stations';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfoIcon from '@material-ui/icons/Info';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import clsx from 'classnames';
import { post } from '../../modules/utility';
import FMPHeadline from '../../components/ui/FMPHeadline';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';
import AddRetailPrice from '../../components/AddRetailPrice';
import Popover from '@material-ui/core/Popover';
import RetailPriceAddNote from '../../components/Dialogs/RetailPriceAddNote';
import FMPStationRegionPicker from '../../components/pureForm/FMPStationRegionPicker';
import FMPStationOwnershipGroupPicker from '../../components/pureForm/FMPStationOwnershipGroupPicker';

const isLocalhost = Boolean(window.location.hostname === 'localhost');

const styles = (theme) => ({
	...getSharedStyles(theme),
	row: {
		cursor: 'pointer',
	},
	popOverPaper: {
		textAlign: 'left',
		boxSizing: 'border-box',
		padding: 20,
	},
	popover: {
		pointerEvents: 'none',
	},
	lockOutNoteContainer: {
		padding: 4,
		border: `1px solid #ddd`,
		borderRadius: 2,
	},
	warningButton: {
		padding: 5,
		border: `1px solid #ddd`,
		borderRadius: 2,
		backgroundColor: '#fafafa',
		textAlign: 'right',
		fontWeight: 300,
		fontSize: '13px',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 17px 8px 10px',
		borderRadius: '30px',
	},
	formControl: {
		fontSize: 14,
		marginLeft: 20,
		flex: 1,
	},
	title: {
		display: 'flex',
		alignItems: 'flex-end',
	},
	label: {},
	value: {
		fontWeight: 600,
	},
	errorRow: {
		backgroundColor: '#FECDD1',
		//backgroundColor : '#FFECF0',
	},
	reportedDateTime: {
		fontSize: '13px',
		fontWeight: 200,
		color: '#555',
		whiteSpace: 'nowrap',
	},
	lockedCell: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
	upDownIcon: {
		marginTop: -9,
		bottom: -9,
		width: 28,
		height: 28,
		position: 'relative',
	},
	warningIcon: {
		marginTop: -9,
		width: 16,
		height: 16,
		position: 'relative',
		bottom: -3,
		marginRight: 3,
		color: '#b57809',
	},
	noteIcon: {
		marginTop: -9,
		width: 16,
		height: 16,
		position: 'relative',
		bottom: -3,
		marginRight: 3,
		color: '#43A047',
	},
	reportInfo: {
		textAlign: 'left',
		padding: '10px 10px',
	},
	controlButton: {
		borderRadius: 100,
		textDecoration: 'none',
		marginTop: 10,
	},
	downloadIcon: {
		marginRight: 5,
	},
	currentEmail: {
		fontSize: 18,
		paddingLeft: 10,
		lineHeight: 1.7,
	},
	helpText: {
		border: '1px solid #eee',
		backgroundColor: '#f7f7f',
		padding: 15,
		margin: 15,
		fontSize: 14,
		color: '#333',
	},
	howCalculated: {
		fontSize: 16,
		color: '#777',
		paddingBottom: 5,
		paddingTop: 10,
		display: 'flex',
		alignItems: 'center',
	},
	analysisTitle: {
		fontWeight: 600,
		fontSize: 17,
		color: '#555',
		paddingBottom: 5,
		paddingTop: 20,
	},
	statLabel: {
		color: '#555',
	},
	statValue: {
		fontWeight: 600,
	},
	subLabel: {
		fontSize: 13,
		color: '#777',
	},
	statTable: {
		border: `1px solid #ddd`,
		padding: 20,
		tableLayout: 'auto',
		backgroundColor: 'white',
		width: '100%',
	},
	stationBreakdownTable: {
		padding: 20,
		tableLayout: 'auto',
		backgroundColor: 'white',
		//width: '100%',
		borderCollapse: 'collapse',
	},
	analysisContainer: {
		//border : `1px solid #ddd`,
		//padding : 20,
	},
	statRow: {
		margin: 0,
		backgroundColor: '#fff',
		fontsize: 16,
	},
	evenRow: {
		backgroundColor: '#eee',
	},
	td: {
		padding: 15,
		whiteSpace: 'nowrap',
	},
	documentIcon: {
		marginRight: 12,
		display: 'inline-block',
		width: 34,
		height: 40,
		backgroundImage: `url('${documentIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
});

const gasBuddyColumns = [
	{ id: 'count', numeric: false, label: '#', padding: 'checkbox' },
	{ id: 'number', numeric: false, label: 'Station', padding: 'checkbox' },
	{
		id: 'previousPrice',
		numeric: true,
		labels: ['Previous $'],
		padding: 'checkbox',
		noSeparator: true,
	},
	{
		id: 'recentPrice',
		numeric: true,
		labels: ['Current $'],
		padding: 'checkbox',
		noSeparator: true,
	},
	//{ id: 'daysLocked', numeric: true, label: 'Locked', padding: 'checkbox' },
	{ id: 'absDiff', numeric: true, label: 'Diff / Lock', padding: 'checkbox' },
	/*
	{
		id: 'ignoredPrice',
		numeric: true,
		labels: ['Locked', 'Out Price'],
		padding: 'checkbox',
		noSeparator: true,
	},
	*/
	{ id: 'freshnessSort', numeric: true, label: 'Freshness', padding: 'checkbox' },
	{ id: 'estimatedMarginSort', numeric: true, label: 'Est. Margin', padding: 'checkbox' },
	{ id: 'currentMonthDailyAverage', numeric: true, label: 'Daily Avg', padding: 'checkbox' },
	{ id: 'freightFullLoad', numeric: true, label: 'Freight', padding: 'checkbox' },
	{ id: 'gasFormulaDisplay', numeric: true, label: 'Gas Formula', padding: 'checkbox' },
	// { id: 'isInRebate', numeric: false, label: 'In Rebate', padding: 'checkbox' },
	// { id: 'isIgnored', numeric: false, label: 'Ignored', padding: 'checkbox' },
	{ id: 'contact', numeric: false, label: 'Contact', padding: 'checkbox' },
];

const stationWithoutPricesColumns = [
	{ id: 'count', numeric: false, label: '#', padding: 'checkbox' },
	{ id: 'number', numeric: false, label: 'Station', padding: 'checkbox' },
	{ id: 'contact', numeric: false, label: 'Contact', padding: 'checkbox' },
];

function getYearMonth({ date }) {
	return `${date.year()}_${date.month()}`;
}

class GasBuddyPrices extends FormComponent {
	constructor(props) {
		super(props);

		this.state = {
			order: 'asc',
			orderBy: 'freshnessSort',
			search: '',
			isRetailNoteDialogOpen: false,
			gasBuddyAlertEmail: undefined,
			gasBuddyIgnoredStationFormattedRows: [],
			commentPopoverAnchor: undefined,
			popoverGasBuddyPrice: undefined,
			ignoredGasBuddyPriceForDialog: {},
			recentGasBuddyPriceForDialog: {},
			// table filters
			tableRegion: 'all',
			tableOwnershipGroup: 'all',
			// stats filters
			statsRegion: 'all',
			statsOwnershipGroup: 'all',
		};

		this.currentMonth = moment();
		this.lastMonth = moment().subtract(1, 'month');
	}

	monthCheck({ date }) {
		const year = date.year();
		const month = date.month();
		const yearMonth = getYearMonth({ date });

		if (!this.props.salesByMonth[yearMonth]) {
			this.props.getMonthlySales({ params: { year, month } });
		}
	}

	componentDidMount() {
		const { gasBuddyIgnoredStations, gasBuddyIgnoredStationSearch } = this.props;

		this.getStationIdsInRebateProgram();

		if (!gasBuddyIgnoredStations) {
			gasBuddyIgnoredStationSearch();
		} else {
			this.gasBuddyIgnoredStationFormat();
		}

		if (!this.props.latestForEachStation) {
			this.props.getRecentGasBuddyPrices({});
		}

		if (!this.props.registryRows) {
			this.props.searchRegistry({});
		}
		if (_.isEmpty(this.props.stations)) {
			this.props.searchStations();
		}

		this.monthCheck({ date: this.currentMonth });
		this.monthCheck({ date: this.lastMonth });
	}

	componentDidUpdate(prevProps) {
		const { registryRows } = this.props;
		if (!prevProps.registryRows && registryRows) {
			const gasBuddyRow = _.find(registryRows, { name: 'gasBuddyAlertEmail' });

			if (!this.state.gasBuddyAlertEmail) {
				this.setState({ gasBuddyAlertEmail: gasBuddyRow.val });
			}
		}

		const { gasBuddyIgnoredStations } = this.props;
		if (
			JSON.stringify(gasBuddyIgnoredStations) !== JSON.stringify(prevProps.gasBuddyIgnoredStations)
		) {
			this.gasBuddyIgnoredStationFormat();
		}
	}

	getStationIdsInRebateProgram = () => {
		const { showErrors } = this.props;
		post({
			method: 'report.sales.getStationIdsInRebateProgram',
			params: {},
			callback: (err, apiResults) => {
				if (err) {
					showErrors(err);
				}
				this.setState({ stationIdsInRebateProgram: apiResults.stationIds });
			},
		});
	};

	gasBuddyIgnoredStationFormat = () => {
		const { classes } = this.props;
		const { gasBuddyIgnoredStations, stationMap, userMap } = this.props;

		gasBuddyIgnoredStations.forEach((gasBuddyIgnoredStation) => {
			const {
				gasBuddyIgnoredStationId,
				stationId,
				createdByUserId,
				dateCreated,
			} = gasBuddyIgnoredStation;
			const station = stationMap[stationId] || { name: 'Missing' };
			const user = userMap[createdByUserId] || { firstName: 'Missing', lastName: '' };

			gasBuddyIgnoredStation.key = gasBuddyIgnoredStationId;
			gasBuddyIgnoredStation.stationDisplay = `${station.number} - ${station.name}`;
			gasBuddyIgnoredStation.createdByDisplay = user.firstName;
			gasBuddyIgnoredStation.dateCreatedDisplay = moment(dateCreated).format('dddd, M/D/YY h:mm a');
			gasBuddyIgnoredStation.removeButton = (
				<Button
					className={classes.button}
					onClick={() => this.handleRemoveIgnoredStation(gasBuddyIgnoredStationId)}
				>
					Remove
				</Button>
			);
		});
		this.setState({ gasBuddyIgnoredStationFormattedRows: gasBuddyIgnoredStations });
	};

	handleRemoveIgnoredStation = (gasBuddyIgnoredStationId) => {
		const { gasBuddyIgnoredStationRemove } = this.props;
		gasBuddyIgnoredStationRemove({ gasBuddyIgnoredStationId });
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleRowClick = (stationId) => {
		this.props.history.push(`/reports/retailPricesForStation/${stationId}`);
	};

	handleRequestSort = (property) => {
		const orderBy = property;
		let order = 'desc';

		// noinspection JSValidateTypes
		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	getDailyAverageByStationId = ({ currentMonthData }) => {
		let dailyAverageByStationId = {};
		currentMonthData.tankDailySales.forEach((tankDailySale) => {
			const { stationId, dailyAverage, isGmoc } = tankDailySale;
			if (!dailyAverageByStationId[stationId]) {
				dailyAverageByStationId[stationId] = 0;
			}
			if (isGmoc) {
				return;
			}
			dailyAverageByStationId[stationId] += _.round(dailyAverage);
		});
		return dailyAverageByStationId;
	};

	handleCommentPopoverOpen = (event, ignored) => {
		this.setState({
			popoverGasBuddyPrice: ignored,
			commentPopoverAnchor: event.currentTarget,
		});
	};
	handleCommentPopoverClose = () => {
		this.setState({ commentPopoverAnchor: null });
	};

	handleOpenRetailNoteDialog = (ignored, recent) => {
		this.setState({
			isRetailNoteDialogOpen: true,
			ignoredGasBuddyPriceForDialog: ignored,
			recentGasBuddyPriceForDialog: recent,
		});
	};

	handleCloseRetailNoteDialog = () => {
		this.setState({
			isRetailNoteDialogOpen: false,
			ignoredGasBuddyPriceForDialog: undefined,
			recentGasBuddyPriceForDialog: undefined,
		});
	};

	render() {
		const {
			latestForEachStation,
			stationIdsWithoutLatestPrice,
			maxStaleDays,
			registryRows,
			classes,
			stationMap,
			gasFormulaMap,
			gasBuddyPriceMap,
			authUser,
			accessToken,
			salesByMonth,
			userMap,
		} = this.props;

		if (
			!salesByMonth ||
			!latestForEachStation ||
			!registryRows ||
			!stationMap ||
			!authUser ||
			!gasBuddyPriceMap
		) {
			return <div>Fetching data...</div>;
		}

		//- Get daily sales
		const currentYearMonth = getYearMonth({ date: this.currentMonth });
		const currentMonthData = salesByMonth[currentYearMonth];
		if (!currentMonthData) {
			return <div>Calculating monthly sales...</div>;
		}

		const dailyAverageByStationId = this.getDailyAverageByStationId({ currentMonthData });

		const {
			order,
			orderBy,
			search,
			stationIdsInRebateProgram,
			gasBuddyIgnoredStationFormattedRows,
		} = this.state;
		const filterByRegionTable = this.state.tableRegion;
		const filterByOwnershipGroupTable = this.state.tableOwnershipGroup;
		const filterByRegionStats = this.state.statsRegion;
		const filterByOwnershipGroupStats = this.state.statsOwnershipGroup;

		const cleanSearch = search.replace(/[^a-z0-9 ]/gi, '');
		const re = new RegExp('^' + cleanSearch, 'i');

		//- This has all the gasBuddy prices for the last 7 days so I have to group by station

		let gasBuddyRows = [];
		const previousPricesTable = [];
		const recentPricesTable = [];
		const marginsTable = [];
		const now = moment();

		const ignoreByStationId = _.keyBy(gasBuddyIgnoredStationFormattedRows, 'stationId');
		const rebateByStationId = _.keyBy(stationIdsInRebateProgram);

		latestForEachStation.forEach((latestForStation) => {
			const {
				stationId,
				recentGasBuddyId,
				previousGasBuddyId,
				ignoredGasBuddyId,
				estimatedMargin,
			} = latestForStation;

			let recent = gasBuddyPriceMap[recentGasBuddyId];
			let previous = gasBuddyPriceMap[previousGasBuddyId];
			let ignored = gasBuddyPriceMap[ignoredGasBuddyId];

			const {
				number,
				name,
				contactName,
				contactPhoneNumber,
				region,
				ownershipGroup,
				freightFullLoad,
				gasFormulaId,
			} = stationMap[stationId];

			const gasFormula = gasFormulaMap[gasFormulaId] || { display: 'Missing' };

			// filter by region (table filters)
			if (filterByRegionTable && filterByRegionTable !== 'all') {
				if (region !== filterByRegionTable) {
					return;
				}
			}

			if (filterByOwnershipGroupTable && filterByOwnershipGroupTable !== 'all') {
				if (ownershipGroup !== filterByOwnershipGroupTable) {
					return;
				}
			}

			//- filter first
			if (search && !re.test(number) && !re.test(name)) {
				return;
			}

			let diff = null;
			let diffIcon = '';
			if (recent && previous) {
				diff = _.round(recent.gasBuddyPrice - previous.gasBuddyPrice, 3);
				if (diff > 0) {
					diffIcon = <UpIcon className={classes.upDownIcon} />;
				} else if (diff < 0) {
					diffIcon = <DownIcon className={classes.upDownIcon} />;
				}
				previousPricesTable.push(previous.gasBuddyPrice);
			}

			recentPricesTable.push(recent.gasBuddyPrice);
			//let estimatedMargin = _.round(recent.gasBuddyPrice - recent.totalCost, 3);
			let estimatedMarginDisplay = estimatedMargin || '-';
			let estimatedMarginSort = estimatedMargin || -100;

			// 2025 removed this as we don't remember why we put this in the first place
			//if (ownershipGroup === 'boyett') {
			//	estimatedMarginDisplay = 'n/a';
			//	estimatedMarginSort = -200;
			//} else {
			marginsTable.push(estimatedMargin);
			//}
			const rowClick = () => this.handleRowClick(stationId);

			const currentMonthDailyAverage = dailyAverageByStationId[stationId] || '-';

			let recentSourceDisplay = _.toUpper(recent.source);
			if (recent.createdByUserId) {
				const user = userMap[recent.createdByUserId] || { firstName: 'Missing', lastName: '' };
				recentSourceDisplay = `${user.firstName}`;
			}

			const { reportedDateTime, lockedUntilDateTime } = recent;

			const recentMoment = moment(reportedDateTime);
			const freshnessSort = now.diff(recentMoment);
			const freshnessDisplay = moment.duration(now.diff(recentMoment)).humanize();

			let daysLocked = null;
			if (lockedUntilDateTime) {
				daysLocked = moment(lockedUntilDateTime).diff(now, 'days');
				if (daysLocked <= 0) {
					daysLocked = null;
				}
			}

			let lockedOutDisplay = '-';
			let ignoredPrice = '-';
			let ignoredReportedDateTime = undefined;
			if (ignored) {
				// const { lockedOutNote } = ignored;
				ignoredPrice = ignored.gasBuddyPrice;
				ignoredReportedDateTime = moment(ignored.reportedDateTime).format('M/D/YY h:mm a');

				//const lockedOutNote = 'This HIS IS FINE i chekc on it and it was  alals good in teh ghood.';
				const { lockedNote } = ignored;

				if (ignoredPrice !== recent.gasBuddyPrice) {
					if (lockedNote) {
						lockedOutDisplay = (
							<div
								className={classes.lockOutNoteContainer}
								onMouseEnter={(event) => {
									this.handleCommentPopoverOpen(event, ignored);
								}}
								onMouseLeave={this.handleCommentPopoverClose}
							>
								<NoteIcon className={classes.noteIcon} />
								{ignoredPrice}
								<div className={classes.reportedDateTime}>{ignoredReportedDateTime}</div>
							</div>
						);
					} else {
						lockedOutDisplay = (
							<Button
								className={classes.warningButton}
								onClick={() => {
									this.handleOpenRetailNoteDialog(ignored, recent);
								}}
							>
								<div style={{ lineHeight: 'normal' }}>
									<div>
										<WarningIcon className={classes.warningIcon} />
										{ignoredPrice}
									</div>
									<div className={classes.reportedDateTime}>{ignoredReportedDateTime}</div>
								</div>
							</Button>
						);
					}
				} else {
					lockedOutDisplay = (
						<div style={{ opacity: 0.8 }}>
							{ignoredPrice}
							<div className={classes.reportedDateTime}>{ignoredReportedDateTime}</div>
						</div>
					);
				}
			}

			// Figure out if we should display the lockedOut for the reported displayed
			let recentReportedDateTime = recentMoment.format('M/D/YY h:mm a');
			if (lockedUntilDateTime && moment(lockedUntilDateTime).isBefore(now)) {
				recentReportedDateTime = moment(lockedUntilDateTime).format('M/D/YY h:mm a') + '*';
			}
			gasBuddyRows.push({
				isIgnored: !!ignoreByStationId[stationId],
				isInRebate: !!rebateByStationId[stationId],
				stationId,
				number,
				name,

				previousPrice: previous ? previous.gasBuddyPrice : '',
				previousReportedDateTime: previous
					? moment(previous.reportedDateTime).format('M/D/YY h:mm a')
					: '',

				recentPrice: recent.gasBuddyPrice,
				recentReportedDateTime: recentReportedDateTime,

				lockedOutDisplay,
				daysLocked,
				recentSourceDisplay,
				diff: diff,
				absDiff: diff === null ? '-' : Math.abs(diff),
				freshnessSort,
				freshnessDisplay,
				diffIcon: diffIcon,
				recentQuotedPrice: recent.quotedPrice,
				recentTotalCost: recent.totalCost,
				currentMonthDailyAverage,
				contact: (
					<Fragment>
						<div>{contactName}</div>
						<div>{contactPhoneNumber}</div>
					</Fragment>
				),
				rowClick,
				estimatedMarginDisplay,
				estimatedMarginSort,
				estimatedMargin,
				freightFullLoad,
				gasFormulaDisplay: gasFormula.display,
			});
		});

		gasBuddyRows = sortStationTable({ rows: gasBuddyRows, orderBy, order });

		let stationWithoutPriceRows = [];
		stationIdsWithoutLatestPrice.forEach((stationId) => {
			const { number, name, contactName, contactPhoneNumber, region, ownershipGroup } = stationMap[
				stationId
			];

			// filter by region (table filters)
			if (filterByRegionTable && filterByRegionTable !== 'all') {
				if (region !== filterByRegionTable) {
					return;
				}
			}

			if (filterByOwnershipGroupTable && filterByOwnershipGroupTable !== 'all') {
				if (ownershipGroup !== filterByOwnershipGroupTable) {
					return;
				}
			}

			//- filter first
			if (search && !re.test(number) && !re.test(name)) {
				return;
			}
			const rowClick = () => this.handleRowClick(stationId);
			const currentMonthDailyAverage = dailyAverageByStationId[stationId] || '-';

			stationWithoutPriceRows.push({
				stationId,
				number,
				name,
				currentMonthDailyAverage,
				contact: (
					<Fragment>
						<div>{contactName}</div>
						<div>{contactPhoneNumber}</div>
					</Fragment>
				),
				rowClick,
			});
		});
		stationWithoutPriceRows = sortStationTable({ rows: stationWithoutPriceRows, orderBy, order });

		// Build stats using independent stats filters
		const statsScopedStations = latestForEachStation.filter((latestForStation) => {
			const { stationId } = latestForStation;
			const { region, ownershipGroup } = stationMap[stationId];
			if (filterByRegionStats && filterByRegionStats !== 'all' && region !== filterByRegionStats) {
				return false;
			}
			if (
				filterByOwnershipGroupStats &&
				filterByOwnershipGroupStats !== 'all' &&
				ownershipGroup !== filterByOwnershipGroupStats
			) {
				return false;
			}
			return true;
		});

		const previousPricesStats = [];
		const recentPricesStats = [];
		const marginsStats = [];
		statsScopedStations.forEach((latestForStation) => {
			const { recentGasBuddyId, previousGasBuddyId, estimatedMargin } = latestForStation;
			const recent = gasBuddyPriceMap[recentGasBuddyId];
			const previous = gasBuddyPriceMap[previousGasBuddyId];
			if (previous && previous.gasBuddyPrice != null) {
				previousPricesStats.push(previous.gasBuddyPrice);
			}
			if (recent && recent.gasBuddyPrice != null) {
				recentPricesStats.push(recent.gasBuddyPrice);
			}
			if (estimatedMargin != null) {
				marginsStats.push(estimatedMargin);
			}
		});

		const stats = [
			{
				label: `Total Reporting Stations`,
				value: statsScopedStations.length,
			},
			{
				label: `Total Stations Without Price`,
				value: stationIdsWithoutLatestPrice?.length,
			},
			{
				label: `Average Previous Price`,
				value: _.round(_.mean(previousPricesStats), 4) || '??',
			},
			{
				label: `Average Recent Price`,
				value: _.round(_.mean(recentPricesStats), 4) || '??',
			},
			{
				label: `Average Estimated Margin`,
				value: _.round(_.mean(marginsStats), 4) || 'n/a',
			},
		];

		const params = {
			method: 'gasBuddyPrice.csv.download',
			params: {
				accessToken,
			},
		};

		let host = '';
		if (isLocalhost) {
			host = 'http://localhost:3700';
		}

		const downloadUrl = `${host}/api?request=${JSON.stringify(params)}`;

		const { popoverGasBuddyPrice } = this.state;
		let popoverDisplay;
		if (popoverGasBuddyPrice) {
			const { lockedNote, lockedNoteDateCreated, lockedNoteByUserId } = popoverGasBuddyPrice;
			const lockedUser = userMap[lockedNoteByUserId] || { firstName: 'Missing' };
			popoverDisplay = (
				<div>
					<div>{lockedNote}</div>
					<div style={{ fontSize: '90%', color: '#666' }}>
						{lockedUser.firstName} @ {moment(lockedNoteDateCreated).format('M/D h:m a')}
					</div>
				</div>
			);
		}

		// Get the latest E85 prices URL from registry
		const latestE85PricesUrl = _.get(_.find(registryRows, { name: 'latestE85PricesUrl' }), 'val');

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Paper className={classes.paper}>
						{latestE85PricesUrl && (
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<div className={classes.documentIcon} />
								<div>
									Download latest OPIS GasBuddy E85Prices Report :&nbsp;
									<a href={latestE85PricesUrl} target="_blank" rel="noreferrer noopener">
										OPIS GasBuddy E85Prices Report
									</a>
								</div>
							</div>
						)}
					</Paper>

					<div style={{ marginTop: 20 }}>
						<Grid container spacing={3}>
							<Grid item xs={8}>
								<FMPHeadline label={'Add Retail Price'} />
							</Grid>
						</Grid>

						<Paper className={classes.paper}>
							<AddRetailPrice
								afterSave={() => {
									this.props.getRecentGasBuddyPrices({});
								}}
							/>
						</Paper>
					</div>

					<div style={{ marginTop: 25 }}>
						<Grid container spacing={2}>
							<Grid item xs={8}>
								<Typography variant="h5" align="left" gutterBottom className={classes.title}>
									<span>Retail Price Stats</span>
								</Typography>
							</Grid>
						</Grid>

						<Paper className={classes.paper}>
							{/* Retail Stats Section */}
							<Grid container spacing={2}>
								{/* Stats filtering options (independent) */}
								<FMPStationRegionPicker
									{...this.setForm(`statsRegion`)}
									contained={false}
									md={4}
									includeAll={true}
									label="Filter Stats by Region"
								/>
								<FMPStationOwnershipGroupPicker
									{...this.setForm(`statsOwnershipGroup`)}
									contained={false}
									includeAll={true}
									md={4}
									label="Filter Stats by Ownership Group"
								/>
							</Grid>

							<Grid container spacing={2} style={{ marginTop: 15 }}>
								<Grid item xs={12} md={12}>
									<FMPSectionHeader label="Stats" isTop={true} />
								</Grid>
								<Grid item xs={12} md={6}>
									{stats.map((stat, i) => {
										return (
											<Grid key={i} container spacing={2}>
												<Grid item lg={5} md={6} xs={5} style={{ textAlign: 'left' }}>
													<span className={classes.label}>{stat.label}</span>
												</Grid>
												<Grid item xs={3} style={{ textAlign: 'right' }}>
													<span className={classes.value}>{stat.value}</span>
												</Grid>
											</Grid>
										);
									})}
								</Grid>
							</Grid>

							<Grid container spacing={2}>
								<Grid item xs={12} md={12}>
									<Accordion>
										<AccordionSummary
											expandIcon={<ExpandMoreIcon />}
											aria-controls="panel1a-content"
											id="panel1a-header"
										>
											<div className={classes.howCalculated}>
												<InfoIcon style={{ paddingRight: 5 }} /> How estimated margin is calculated
											</div>
										</AccordionSummary>
										<AccordionDetails>
											<div>
												<div className={classes.analysisTitle}>Calculations</div>
												The FMP system takes the latest reported retail price we get from our SMS /
												Gas Buddy / OPIS and then matches that up with the previous invoiced price
												we issued the customer. It takes the entire invoice (fuel cost, freight,
												taxes) and then divides that by the amount of fuel to determine the cost per
												gallon. It then looks up sales tax assigned to that station (if a tax has
												not been set yet, it falls back to .0925), and adds the sales tax to the
												cost per gallon. Then the system calculates the difference between that and
												the retail price.
												<br />
												<br />
												<strong>Notes:</strong>
												<br />
												1. All our quoted prices include freight and the freight is quoted for a
												Full Load. If the station gets a split load or a half load unable to split
												then the freight prices will be higher, and hence the quoted price will be
												higher and the margin will be less in those cases.
												<br />
												2. If you look at historical reports the FMP gets all the invoices and uses
												that to determine the fuel cost for the given period of time until the next
												invoice comes in.
												<br />
											</div>
										</AccordionDetails>
									</Accordion>
								</Grid>
							</Grid>
						</Paper>
					</div>

					<div style={{ marginTop: 25 }}>
						<Grid container spacing={3}>
							<Grid item xs={8}>
								<Typography variant="h5" align="left" gutterBottom className={classes.title}>
									<span>Retail Prices</span>
									<TextField
										className={classes.formControl}
										value={this.state.search}
										onChange={(event) => this.handleSearch(event)}
										label="Type to search"
										fullWidth
									/>
								</Typography>
							</Grid>
							<Grid
								item
								xs={4}
								align="right"
								style={{ justifyContent: 'flex-end', alignItems: 'flex-end' }}
							>
								<a
									href={downloadUrl}
									style={{ textDecoration: 'none' }}
									target="_blank"
									rel="noreferrer noopener"
								>
									<Button className={classes.button} variant="contained" color="primary">
										<FileDownload className={classes.downloadIcon} />
										DOWNLOAD CSV
									</Button>
								</a>
							</Grid>
						</Grid>

						<Paper className={classes.paper}>
							{/* Table Filtering Options (independent) */}
							<Grid container spacing={2}>
								<FMPStationRegionPicker
									{...this.setForm(`tableRegion`)}
									contained={false}
									md={4}
									includeAll={true}
									label="Filter Table by Region"
								/>
								<FMPStationOwnershipGroupPicker
									{...this.setForm(`tableOwnershipGroup`)}
									contained={false}
									includeAll={true}
									md={4}
									label="Filter Table by Ownership Group"
								/>
							</Grid>

							<hr style={{ opacity: 0.5, margin: '20px 0px' }} />

							<Table stickyHeader size="small" className={classes.table}>
								<EnhancedTableHead
									columnData={gasBuddyColumns}
									order={order}
									orderBy={orderBy}
									onRequestSort={this.handleRequestSort}
								/>
								<TableBody>
									{gasBuddyRows.map((n, i) => {
										return (
											<TableRow
												hover
												className={classes.row}
												style={{ opacity: n.isIgnored ? 0.4 : 1 }}
												key={`${n.stationId}`}
											>
												<TableCell onClick={n.rowClick}>{i + 1}</TableCell>
												<TableCell onClick={n.rowClick}>
													{n.number} - {n.name}
												</TableCell>
												<TableCell onClick={n.rowClick} align="right">
													{n.previousPrice}
													<div className={classes.reportedDateTime}>
														{n.previousReportedDateTime}
													</div>
												</TableCell>
												<TableCell onClick={n.rowClick} align="right">
													<div style={{ fontWeight: '600' }}>{n.recentPrice}</div>
													<div className={classes.reportedDateTime}>{n.recentReportedDateTime}</div>
												</TableCell>

												<TableCell
													onClick={n.rowClick}
													align="right"
													style={{ whiteSpace: 'nowrap' }}
												>
													<div>
														{n.diffIcon} {n.absDiff}
													</div>

													<div style={{ fontSize: '13px', marginTop: '3px' }}>
														{!!n.daysLocked && (
															<div className={classes.lockedCell}>
																<LockIcon style={{ fontSize: '1rem', opacity: '.7' }} />{' '}
																{n.daysLocked}d
															</div>
														)}
														{!n.daysLocked && <div>-</div>}
													</div>
												</TableCell>

												<TableCell onClick={n.rowClick} align="right">
													<div>{n.freshnessDisplay}</div>
													<div style={{ marginTop: '3px', fontSize: '12px' }}>
														{n.recentSourceDisplay}
													</div>
												</TableCell>
												<TableCell onClick={n.rowClick} align="right">
													{n.estimatedMarginDisplay}
												</TableCell>
												<TableCell onClick={n.rowClick} align="right">
													{n.currentMonthDailyAverage}
												</TableCell>

												<TableCell onClick={n.rowClick} align="right">
													{n.freightFullLoad}
												</TableCell>

												<TableCell onClick={n.rowClick} align="right">
													{n.gasFormulaDisplay}
												</TableCell>

												<TableCell onClick={n.rowClick}>{n.contact}</TableCell>
											</TableRow>
										);
									})}
								</TableBody>
							</Table>
						</Paper>
					</div>

					<hr style={{ opacity: 0.5, margin: '20px 0px' }} />

					<div
						style={{
							textAlign: 'left',
							fontSize: 20,
							fontWeight: 400,
							marginBottom: 5,
						}}
					>
						Stations Without Retail Price
					</div>
					<Paper className={classes.paper} style={{ marginBottom: 10 }}>
						<div>
							Note: Stations in the following table indicate that we have not received a price in
							the last <strong>{maxStaleDays}</strong> days for the station and we will not be
							displaying a price for this station in the app (shows a fuel pump instead).
						</div>
					</Paper>

					<Table stickyHeader size="small" className={classes.table}>
						<EnhancedTableHead
							columnData={stationWithoutPricesColumns}
							order={order}
							orderBy={orderBy}
							onRequestSort={this.handleRequestSort}
						/>
						<TableBody>
							{stationWithoutPriceRows.map((n, i) => {
								return (
									<TableRow
										hover
										className={classes.row}
										style={{ opacity: n.isIgnored ? 0.4 : 1 }}
										key={`${n.stationId}`}
									>
										<TableCell onClick={n.rowClick}>{i + 1}</TableCell>

										<TableCell onClick={n.rowClick}>
											{n.number} - {n.name}
										</TableCell>
										<TableCell onClick={n.rowClick}>{n.contact}</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>

					<Popover
						id="comment-popover"
						className={classes.popover}
						classes={{ paper: classes.popOverPaper }}
						open={!!this.state.commentPopoverAnchor}
						anchorEl={this.state.commentPopoverAnchor}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'left',
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'left',
						}}
						onClose={this.state.handleCommentPopoverClose}
						disableRestoreFocus
					>
						<div className={classes.commentsContainer}>{popoverDisplay}</div>
					</Popover>

					<RetailPriceAddNote
						onClose={this.handleCloseRetailNoteDialog}
						ignoredGasBuddyPrice={this.state.ignoredGasBuddyPriceForDialog}
						recentGasBuddyPrice={this.state.recentGasBuddyPriceForDialog}
						open={this.state.isRetailNoteDialogOpen}
						history={this.props.history}
					/>
				</Grid>
			</Grid>
		);
	}

	drawOverallStats = ({ overallStats }) => {
		const { classes } = this.props;
		return (
			<>
				{overallStats.map((stat, i) => {
					const isOdd = i % 2;
					const { value, label, subLabel } = stat;
					return (
						<tr key={i} className={clsx(classes.statRow, !isOdd ? classes.evenRow : '')}>
							<td className={classes.td} style={{ textAlign: 'left' }}>
								<div className={classes.statLabel}>{label}</div>
								{subLabel && <div className={classes.subLabel}>{subLabel}</div>}
							</td>
							<td className={clsx(classes.td, stat.diffClass)} style={{ textAlign: 'right' }}>
								{stat.diffIcon && stat.diffIcon}
								<span className={classes.statValue}>{value}</span>
							</td>
						</tr>
					);
				})}
			</>
		);
	};
}

GasBuddyPrices.propTypes = {
	classes: PropTypes.object.isRequired,
	getMonthlySales: PropTypes.func.isRequired,
	salesByMonth: PropTypes.object,

	getRecentGasBuddyPrices: PropTypes.func.isRequired,
	latestForEachStation: PropTypes.array,

	gasBuddyIgnoredStationSearch: PropTypes.func.isRequired,
	gasBuddyIgnoredStationAdd: PropTypes.func.isRequired,
	gasBuddyIgnoredStationRemove: PropTypes.func.isRequired,
	gasBuddyIgnoredStations: PropTypes.array,

	stationMap: PropTypes.object,
	userMap: PropTypes.object,
	gasBuddyPriceMap: PropTypes.object,

	searchRegistry: PropTypes.func,
	updateRegistry: PropTypes.func,
	registryRows: PropTypes.array,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	authUser: PropTypes.object,
	accessToken: PropTypes.string,
	stations: PropTypes.array,
	searchStations: PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles),
	ReportsMonitoringContainer,
	GasBuddyPricesContainer,
	GasBuddyIgnoredStationsContainer,
	RegistryContainer,
	StationsContainer,
])(GasBuddyPrices);
